// extracted by mini-css-extract-plugin
export default {"melodyVideo":"hQ-z","isFullWidth":"iQ-z","landingPageVideo":"jQ-z","play":"kQ-z","iframeVideo":"lQ-z","playHidden":"mQ-z","fullwidth":"nQ-z"};